import { BaseModel } from "sjs-base-model";

export default class LightProjectModel extends BaseModel {
  public readonly slug: string = "";
  public readonly name: string = "";

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<LightProjectModel>) {
    super();

    this.update(data);
  }
}
